import {APIEvents} from "../../../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "../../base/ClientInterface";

export function getShipmentsByScannableId(data, dispatcher, nextAction, errorAction) {
    let startTime = Date.now();
    getNPSWClient().getShipmentsByScannableId(data)
        .then(({success, data}) => {
            if (success && data && data.shipments && data.shipments.length) {
                dispatcher({
                    type: nextAction,
                    data: data,
                    dispatcher: dispatcher
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetShipmentsByScannableIds, startTime);
            } else {
                dispatcher({
                    type: errorAction
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetShipmentsByScannableIds, startTime, true);
            }
        });
    }